// Auto generated file, do not manually modify!
// com.hotpads.rewardsapi.client.enums.RewardsApiTransactionType

export enum RewardsApiTransactionType {
  ENROLLMENT_BONUS = 'ENROLLMENT_BONUS',
  RENT_PAYMENT = 'RENT_PAYMENT',
  RENT_PAYMENT_REFUNDED = 'RENT_PAYMENT_REFUNDED',
}

export const RewardsApiTransactionType_values = [
  RewardsApiTransactionType.ENROLLMENT_BONUS,
  RewardsApiTransactionType.RENT_PAYMENT,
  RewardsApiTransactionType.RENT_PAYMENT_REFUNDED,
] as const;
